import { Injectable } from '@angular/core';

import { isDateValid } from '@casinocore/platform/utils';
import { Logger, Message, MessageLifetime, MessageType, TrackingService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { betmgmOriginalsSitecoreData } from '../client-config/betmgmoriginals-config';
import { ConfigProviderService } from '../config-provider/config-provider.service';
import { PlatformApiService } from '../platform-api/platform-api.service';
import { BetMGMOriginalsRequestModel } from './models/betmgm-originals.model';

@Injectable({
    providedIn: 'root',
})
export class BetmgmOriginalsService {
    observable: Observable<any | null>;
    private optInPublisher = new BehaviorSubject<boolean>(false);
    optInObservable: Observable<boolean | null>;
    private getOptInPublisher = new BehaviorSubject<boolean>(false);
    getOptInObservable: Observable<boolean | null>;
    private publisher = new BehaviorSubject<boolean>(false);
    private betMgmOriginalsTimerPublisher = new BehaviorSubject<boolean>(true);
    betMgmOriginalsTimerObservable: Observable<boolean | null>;
    betmgmOriginalConfig: boolean;
    betmgmOriginalsSitecoreData: betmgmOriginalsSitecoreData;
    overLaySitecoreData: any;
    BetmgmOriginalOptInData: any;
    bottomSheetRef: any;
    dialogRef: any;

    constructor(
        private configProviderService: ConfigProviderService,
        private api: PlatformApiService,
        private logger: Logger,
        private trackingService: TrackingService,
    ) {
        this.betmgmOriginalConfig = this.configProviderService?.providerBetMGMOriginalsConfig()?.enabledBetMGMOriginals;
        this.betmgmOriginalsSitecoreData = this.configProviderService?.providerBetMGMOriginalsConfig()?.betmgmOriginalsConfigurations;
        this.observable = this.publisher.asObservable();
        this.optInObservable = this.optInPublisher.asObservable();
        this.getOptInObservable = this.getOptInPublisher.asObservable();
        this.betMgmOriginalsTimerObservable = this.betMgmOriginalsTimerPublisher.asObservable();
    }

    get betmgmoriginalOptIn(): any {
        return this.BetmgmOriginalOptInData;
    }

    getBetmgmOriginalsUserStatus(type: string, id: string): void {
        this.api
            .get(
                'betmgmoriginals/GetBetMGMOriginalsStatus',
                { type: type, id: id },
                {
                    responseType: 'json',
                    withCredentials: true,
                },
            )
            .subscribe({
                next: (response: any) => {
                    if (response) {
                        this.getOptInPublisher.next(response);
                    }
                },
                error: (error: string) => {
                    const message: Message = {
                        html: error,
                        type: MessageType.Error,
                        lifetime: MessageLifetime.Single,
                    };
                    this.logger.error(message);
                },
            });
    }
    postBetmgmOptIn(postRequestModel: BetMGMOriginalsRequestModel): void {
        this.api
            .post('betmgmoriginals/PostBetMGMOriginalsStatus', postRequestModel, {
                responseType: 'json',
                withCredentials: true,
            })
            .subscribe({
                next: (response: any) => {
                    if (response) {
                        this.optInPublisher.next(response);
                    }
                },
                error: (error: string) => {
                    const message: Message = {
                        html: error,
                        type: MessageType.Error,
                        lifetime: MessageLifetime.Single,
                    };
                    this.logger.error(message);
                },
            });
    }
    trackEvent(
        trackingType: string,
        categoryEvent: string,
        labelEvent: string,
        actionEvent: string,
        positionEvent: string,
        locationEvent: string,
        eventDetails: string,
        uRLClicked: string,
    ): void {
        this.trackingService.triggerEvent(trackingType, {
            'component.CategoryEvent': categoryEvent,
            'component.LabelEvent': labelEvent,
            'component.ActionEvent': actionEvent,
            'component.PositionEvent': positionEvent,
            'component.LocationEvent': locationEvent,
            'component.EventDetails': eventDetails,
            'component.URLClicked': uRLClicked,
        });
    }
    setOriginalsTimerStatus(isTimerRunning: boolean): void {
        this.betMgmOriginalsTimerPublisher.next(isTimerRunning);
    }

    isTimerValidForOriginals(timerExpiryDate: string): boolean {
        if (isDateValid(timerExpiryDate)) {
            const targetDate = new Date(timerExpiryDate);
            const milliseconds = targetDate.getTime() - new Date().getTime();
            if (milliseconds <= 0) {
                return false;
            }
            return true;
        }
        return false;
    }

    validateBetMgmOriginalsConfigs(displayBetMGMOriginals: boolean, betMGMOriginalsConfig: any, isUserAuthenticated: boolean): boolean {
        return (
            betMGMOriginalsConfig?.enabledBetMGMOriginals &&
            isUserAuthenticated &&
            displayBetMGMOriginals &&
            betMGMOriginalsConfig?.betmgmOriginalsConfigurations?.SourceType &&
            betMGMOriginalsConfig?.betmgmOriginalsConfigurations?.SourceId &&
            this.isTimerValidForOriginals(betMGMOriginalsConfig?.betmgmOriginalsConfigurations?.TimerExpiryDate)
        );
    }
}
